import z from 'zod';

export type ResizableMediaDto = {
	id: string;
	url: string;
	availableSizes: number[];
};

export const ResizableMediaDtoSchema: z.ZodType<ResizableMediaDto> = z.object({
	id: z.string(),
	url: z.string(),
	availableSizes: z.number().array(),
});
